import TechAppDialog from './TechAppDialog'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { useState } from 'react'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField';

type SelectDescriptionDialogProperties = {
    workorder_id?: number;
    onClose(): void;
    timeType: string;
    descriptions: any[];
    onStartTechTime(workorder_id: number, timeType: string, reasonId: number, extraDescription: string): void;
}

export default function SelectDescriptionDlg(props: SelectDescriptionDialogProperties){
    const [reason, setReason] = useState(0)
    const [extraDescription, setExtraDescription] = useState('')
    const [invalidReason, setInvalidReason] = useState(false)

    const validateReason = (desc: number) => {
        setInvalidReason(desc === 0)
        return desc > 0
    }

    const onReasonChange = (event: any) => {
        const reasonId = parseInt(event.target.value)
        setReason(reasonId)
        validateReason(reasonId)
    }

    let descItems: any[] = []
    if(props.descriptions)
        descItems = props.descriptions.map((item: any) => {
            return (<MenuItem key={`desc_${item.id}`} value={item.id}>{item.name}</MenuItem>)
        })

    const startTechTime = () => {
        const validDesc = validateReason(reason)
        if(!validDesc) return
        props.onStartTechTime(
            props.workorder_id ? props.workorder_id : 0,
            props.timeType,
            reason ? reason : 0,
            extraDescription ? extraDescription : '')
        props.onClose()
    }

    const timeTypeLabel = props.timeType === 'travel' ? 'Travel' :
        props.timeType === 'idle' ? 'Idle' :
        props.timeType === 'wo_labor' ? 'Labor' :
        'Diagnostics'

    return (
        <TechAppDialog
            open={true}
            title={`Start ${timeTypeLabel}`}
            onClose={props.onClose}
            buttons={[{text:`Start ${timeTypeLabel}`, onClick:startTechTime, primary: true},
                      {text:'Cancel', onClick:props.onClose}]}
        >
            <form className="dialog-form">
                {props.workorder_id ? (<span>{'WO-'+('' + props.workorder_id).padStart(5, '0')}</span>) : (<></>)}
                <FormControl className="full_width dialog_form_control">
                    <InputLabel>Reason</InputLabel>
                    <Select
                        fullWidth
                        value={reason}
                        onChange={onReasonChange}
                    >
                        <MenuItem value={'0'}></MenuItem>
                        {descItems}
                    </Select>
                    {invalidReason ? (<FormHelperText>Select Description</FormHelperText>):(<></>)}
                </FormControl>
                <FormControl className="full_width dialog_form_control">
                    <TextField
                        id="text_edit_multiline"
                        multiline
                        fullWidth
                        rows={20}
                        label="Extra Description"
                        value={extraDescription}
                        onChange={(event) => setExtraDescription(event.target.value)}
                    />
                </FormControl>
            </form>
        </TechAppDialog>
    )
}